import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { member_search, member_edit, file_upload } from "../../components/apipath";
import SwitchBox from "../../components/switchBox";
import { switchHelper, dateHelper, textHelper } from "../../modules/helpers";
import PageList from "../../components/pageList";

function AdmMemberView() {
  const [memberlist, setMemberlist] = useState([]);
  const [conditions, setConditions] = useState(null);
  const [rowsCount, setRowsCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const { token } = useAuth();

  const memberStatus = ["請選擇", "在職者", "在學生", "全職考生", "待業中"];
  const memberAccountStatus = ["請選擇", "停用", "啟用"];
  // const userTypes = ["請選擇", "CPA", "CMA"];
  const products = ["請選擇", "CPA專業方案", "CPA全修方案", "CPA選修方案", "CPA自修方案", "CPA單科雙語", "CMA自修方案", "CMA菁英方案", "EA速成方案", "EA完勝方案", "CSU學分班", "CPE", "個人所得稅", "財產交易稅", "公司所得稅", "穿透實體稅務", "衝刺方案", "職涯無限方案"];
  const PRODUCT_OPTIONS = products
    .map((label, idx) => ({ id: String(idx), label }))
    .filter(opt => opt.id !== "0");
    
  const thisYear = new Date().getFullYear();
  const yearList = (y) => {
    const years = ["請選擇"];
    for (let i = y; i >= 2017; i--) years.push(i);
    return years;
  };

  // 初始條件
  useEffect(() => {
    setConditions({
      year: null,
      product_id: null,
      user_type: null,
      pass: null,
      refund: null,
      chinese_name: null,
      email: null,
      account_status: null,
      status: null,
      mem_status: null,
    });
  }, []);

  // 乾淨 payload：把空字串→null、必要欄位轉型
  const makePayload = () => {
    const payload = {
      year: conditions?.year ?? null,
      product_id:
        conditions?.product_id === "" || conditions?.product_id == null
          ? null
          : Number(conditions.product_id),
      user_type: conditions?.user_type || null, // 'CPA'|'CMA'|null
      pass:
        typeof conditions?.pass === "boolean"
          ? (conditions.pass ? 1 : 0)
          : conditions?.pass ?? null,
      refund:
        typeof conditions?.refund === "boolean"
          ? (conditions.refund ? 1 : 0)
          : conditions?.refund ?? null,
      chinese_name: conditions?.chinese_name?.trim() || null,
      email: conditions?.email?.trim() || null,
      account_status:
        conditions?.account_status === "" || conditions?.account_status == null
          ? null
          : Number(conditions.account_status), // -1/0/1 看 DB 定義，這裡假設 0 停用、1 啟用
      status:
        conditions?.status === "" || conditions?.status == null
          ? null
          : Number(conditions.status), // 1~4
      mem_status:
        typeof conditions?.mem_status === "boolean"
          ? (conditions.mem_status ? 1 : 0)
          : conditions?.mem_status ?? null,
    };

    // 統一把 "" 變 null
    Object.keys(payload).forEach((k) => {
      if (payload[k] === "") payload[k] = null;
    });

    return payload;
  };

  const fetchData = async (page = 1, rows = 50) => {
    try {
      setLoading(true);
      if (page <= 0) page = 1;

      const payload = makePayload();
      const { data: resp } = await axios.post(member_search(page - 1, rows), payload, {
        headers: { token },
      });

      const list = resp?.[0]?.data || [];
      // 過濾 [{}] 這種空物件
      const cleaned = list.filter((row) => row && Object.keys(row).length > 0 && row.mem_id != null);
      setMemberlist(cleaned);

      const total = resp?.[1]?.data?.[0]?.total ?? 0;
      setRowsCount(total);
    } catch (err) {
      console.error("fetchData error:", err);
      setMemberlist([]);
      setRowsCount(0);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    if (type === "checkbox") {
      setConditions((prev) => ({
        ...prev,
        [name]: switchHelper(checked), // 你們現有 helper：true/false
      }));
    } else {
      setConditions((prev) => ({
        ...prev,
        [name]: value === "" ? null : value,
      }));
    }
  };

  const handleSearch = () => fetchData(1, 50);

  return (
    <>
      <div className="container-fluid p-5 mt-5">
        {conditions && (
          <>
            <div className="row g-2">
              <div className="col-xl-2 col-md-3 col-4">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">年度</span>
                  <select
                    className="form-select form-select-sm"
                    name="year"
                    value={textHelper(conditions.year)}
                    onChange={handleInputChange}
                  >
                    {yearList(thisYear).map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-xl-2 col-md-3 col-4">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">方案</span>
                  <select
                    className="form-select form-select-sm"
                    name="product_id"
                    value={textHelper(conditions.product_id)}
                    onChange={handleInputChange}
                  >
                    {products.map((value, index) => (
                      <option key={index} value={index === 0 ? "" : index}>
                        {value}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* <div className="col-xl-2 col-md-3 col-4">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">科目</span>
                  <select
                    className="form-select form-select-sm"
                    name="user_type"
                    value={textHelper(conditions.user_type)}
                    onChange={handleInputChange}
                  >
                    {userTypes.map((value, index) => (
                      <option key={index} value={index === 0 ? "" : value}>
                        {value}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}
              <div className="col-xl-2 col-md-3 col-4">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">狀態</span>
                  <select
                    className="form-select form-select-sm"
                    name="status" // ★ 對應後端 status 欄
                    value={textHelper(conditions.status)}
                    onChange={handleInputChange}
                  >
                    {memberStatus.map((value, index) => (
                      <option key={index} value={index === 0 ? "" : index}>
                        {value}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-xl-2 col-md-3 col-4">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">帳戶狀態</span>
                  <select
                    className="form-select form-select-sm"
                    name="account_status"
                    value={textHelper(conditions.account_status)}
                    onChange={handleInputChange}
                  >
                    {memberAccountStatus.map((value, index) => (
                      <option key={index - 1} value={index === 0 ? "" : index - 1}>
                        {value}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-xl-1 col-md-2 col-4">
                <div className="input-group input-group-sm">
                  {SwitchBox("pass", conditions.pass, handleInputChange, "已通過")}
                </div>
              </div>

              <div className="col-xl-1 col-md-2 col-4">
                <div className="input-group input-group-sm">
                  {SwitchBox("refund", conditions.refund, handleInputChange, "已退費")}
                </div>
              </div>

              <div className="col-xl-1 col-md-2 col-4">
                <div className="input-group input-group-sm">
                  {SwitchBox("mem_status", conditions.mem_status, handleInputChange, "學員")}
                </div>
              </div>
            </div>
            <div className="row g-2">
              <div className="col-xl-3 col-md-4 col-12">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">姓名</span>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="輸入姓名"
                    name="chinese_name"
                    value={textHelper(conditions.chinese_name)}
                    onChange={handleInputChange}
                    maxLength={200}
                  />
                </div>
              </div>

              <div className="col-xl-3 col-md-4 col-12">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">Email</span>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="輸入 Email"
                    name="email"
                    value={textHelper(conditions.email)}
                    onChange={handleInputChange}
                    maxLength={200}
                  />
                </div>
              </div>

              

              <div className="col-xl-1 col-md-10 col-12 text-xl-end text-md-end text-sm-center">
                <button className="btn btn-primary btn-sm" onClick={handleSearch} disabled={loading}>
                  {loading ? "搜尋中…" : "搜尋"}
                </button>
              </div>
            </div>
          </>
        )}

        <div className="mt-2 table-responsive">
          <table className="table table-striped border table-hover">
            <thead>
              <tr>
                <td>姓名</td>
                {/* <td>科目</td> */}
                <td>帳號</td>
                <td>手機</td>
                <td>信箱</td>
                <td>創建日期</td>
                <td>功能</td>
                <td>編輯</td>
              </tr>
            </thead>
            <tbody>
              {memberlist.map((member) =>
                member.mem_id ? (
                  <tr key={member.mem_id}>
                    <td>{member.chinese_name}</td>
                    {/* <td>{member.user_type}</td> */}
                    <td>{member.account}</td>
                    <td>{member.phone_num}</td>
                    <td>{member.email}</td>
                    <td>{dateHelper(member.createtime, "date")}</td>
                    <td>
                      <div className="g-2">
                        <a
                          href={`${file_upload}member/${member.mem_id}/mResume`}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-secondary btn-sm m-1 p-1"
                        >
                          履歷
                        </a>
                        <a
                          href={`${file_upload}member/${member.mem_id}/mTranscript`}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-secondary btn-sm m-1 p-1"
                        >
                          成績單
                        </a>
                        <a
                          href={`${file_upload}member/${member.mem_id}/mInterview`}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-secondary btn-sm m-1 p-1"
                        >
                          諮詢紀錄
                        </a>
                        <a
                          href={`${file_upload}member/${member.mem_id}/mApplication`}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-secondary btn-sm m-1 p-1"
                        >
                          報考文件
                        </a>
                        <a
                          href={`${file_upload}member/${member.mem_id}/mAcademic`}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-secondary btn-sm m-1 p-1"
                        >
                          學歷認證
                        </a>
                      </div>
                    </td>
                    <td>
                      <Link
                        className="btn btn-primary btn-sm"
                        to={member_edit + member.mem_id}
                      >
                        編輯
                      </Link>
                    </td>
                  </tr>
                ) : null
              )}
              {!loading && memberlist.length === 0 && (
                <tr>
                  <td colSpan={8} className="text-center text-muted">
                    無資料
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="m-2 p-2">{PageList(rowsCount, fetchData)}</div>
      </div>
    </>
  );
}

export default AdmMemberView;
